import { createAction, props } from '@ngrx/store';
import { AccountUsers } from '../models/account-users';

export const tryLoadAccountUsers = createAction('[Account Users] Try Load');
export const loadAccountUsersSuccess = createAction(
  '[Common Company Contacts] Load Success',
  props<{ users: AccountUsers[] }>()
);
export const loadAccountUsersFail = createAction('[Account Users] Load Fail', props<{ error: unknown }>());
